import './wxp_helpers.js';

(function ($, browserDetection, wxpHelpers) {
    'use strict';
    var player_autocomplete = {};

    var PLATFORM_SVG_CLASS = 'js-svg-icon-platform';
    var PLATFORM_SVG_SELECTOR = '.' + PLATFORM_SVG_CLASS;
    var INPUT_WRAPPER_CLASS = 'forms_input_wrapper forms_input_wrapper__withclose';
    var INPUT_WRAPPER_CHECKING_CLASS = 'forms_input_wrapper__checking';

    player_autocomplete.activateAutocomplete = function (options) {
        var searchInputSelector = options.searchInputSelector;
        var autocompleteViewAllSelector = options.autocompleteViewAllSelector;
        var autocompleteWrapperSelector = options.autocompleteWrapperSelector;
        var noResultsSelector = options.noResultsSelector;
        var clearSelector = options.clearSelector;
        var submitHandler = options.submitHandler;
        var clearHandler = options.clearHandler;
        var selectedHandler = options.selectedHandler;	// selectedHandler should return true if it also handles all UI effects
        var changeLocation = typeof(options.changeLocation != 'undefined') ? options.changeLocation : true;
        var platform = options.platform;

        var $search = $(searchInputSelector);
        var searchHasFocus = $search.is(':focus');
        var $wrapper = $search.wrap($('<span>').addClass(INPUT_WRAPPER_CLASS)).parent();
        if (searchHasFocus)
            $search.focus(); // workaround for https://github.com/jquery/jquery/issues/3165
        var $searchForm = $search.parents('form');
        var $viewAll = $(autocompleteViewAllSelector);
        var $noResults = $(noResultsSelector);
        var $autocompleteCustomWrapper = $(autocompleteWrapperSelector).detach();

        if ($noResults.length == 0) {
            $noResults = $('<div>').css({
                    'text-align': 'center',
                    'font-size': 'xx-small',
                    'padding': '5px',
                    'background': 'black',
                    'color': 'grey'
                })
                .text(gettext("no matches")).appendTo($autocompleteCustomWrapper);
        }


        var autocompleteObj = new wxpHelpers.autocomplete(searchInputSelector, window.SEARCH_AUTOCOMPLETE_URL, {
            clearSelector: clearSelector,
            autoApply: options.autoApply || false,
            autoSelectExactMatch: true,
            minlength: window.MIN_LENGTH_FOR_AUTOCOMPLETE || 1,
            customWrapper: $autocompleteCustomWrapper,
            changeLocation: changeLocation,
            platform: platform,
            dataprocessor: function (data) {
                $wrapper.addClass(INPUT_WRAPPER_CHECKING_CLASS);
                return data;
            },
            responseDataPreprocessor: function (data) {
                $wrapper.removeClass(INPUT_WRAPPER_CHECKING_CLASS);

                setTimeout(function () {
                    SVGInjector(document.querySelectorAll(PLATFORM_SVG_SELECTOR), {each: SVGAutoResize});
                }, 0);

                if (!data)
                    return null;
                // limit to 10 items
                return {result: data.result.slice(0, 10)};
            },
            preprocessor: function (data, search) {
                var value = $.trim(data[0]),
                    index;

                search = $.trim(search);
                index = value.toLowerCase().indexOf(search.toLowerCase());
                index = index < 0 ? 0 : index;

                var $item = $('<span>');
                var $icon = $('<span>');
                var $textMatch = $('<span>');
                $item.attr({
                    'data-url': data[1],
                    'data-value': encodeURIComponent(data[0]),
                    'data-spaid': data[2],
                    'data-platform': data[3]
                });
                $icon.addClass('svg-icon svg-icon__platform-positive ' + PLATFORM_SVG_CLASS + ' js-svg-autosize-from-height');
                $icon.attr('data-src', STATIC_URL + 'portal/img/svg-icons/platform/positive/' + data[3] + '.svg');
                $textMatch.addClass('b-autocomplete_match').text(value.substr(index, search.length));

                $item.append($textMatch, value.substr(index + search.length), $icon);
                return $item;
            },
            selectedHandler: selectedHandler ? selectedHandler : function ($item) {
                if ($item.length) {
                    window.location = $item.children('span').data('url');
                    return true;
                } else {
                    $searchForm.submit();
                }
            },
            clearHandler: clearHandler,
            viewallElement: $viewAll,
            noResultsElement: $noResults,

        });

        $searchForm.submit(function (e) {
            if (Modernizr.touchevents) {
                $search.blur();
            }
            if (typeof(submitHandler) == 'function') {
                if (!submitHandler())
                    e.preventDefault();
            } else if (submitHandler)
                console.error("submitHandler must be a function");

            //autocompleteObj.preventAutocomplete();
        });
        return autocompleteObj;
    };
    window.player_autocomplete = player_autocomplete;
})(jQuery, BROWSER_DETECTION_MODULE, WXP_HELPERS_MODULE);
